module.exports = __webpack_public_path__ + "static/Swiggy-8113c16e2b739f3a51eae68b357bd443.jpg";